module.exports = __webpack_public_path__ + "img/47_36.0cab451d.png";